import nacanacaLogo from '../../../../assets/logo.webp';
import logoInicio from '../../../../assets/logodeinicio.webp';
import puntos1 from '../../../../assets/puntos1.webp';
import { Panel, replayButton } from './ExperienceLayout';

export default function OnboardingScreen({
  onboardingStep, email, setEmail, emailError, setEmailError, formNotice,
  name, setName, nameError, setNameError, acceptsEventInfo, setAcceptsEventInfo,
  authMode, mailNotice, verificationCode, setVerificationCode,
  verificationError, setVerificationError, isCheckingEmail, isRegistering,
  isVerifying, isResending, continueWithEmail, continueWithRegistration,
  continueWithVerification, resendCode, enterFromInstructions,
  setOnboardingStep, setFormNotice,
}) {
  return (
<Panel hideFooter>
    {onboardingStep === 'email' ? (
      <>
        <div className="logo-layer relative mx-auto w-[min(88vw,380px)] shrink-0 [isolation:isolate]">
          <img src={logoInicio} alt="La Maldición del Ñaca Ñaca" draggable="false" className="block h-auto w-full object-contain" />
        </div>
        <p className="mt-3 border-l-2 border-[#7EC54A] pl-4 text-left text-xs leading-5 text-[#C5E6A0] md:mt-4 md:text-sm md:leading-6">
          El Diablito despertó. Sigue el ritmo, maldice tu zona y deja una huella en la ciudad.
        </p>
        <form onSubmit={continueWithEmail} noValidate>
        <label className="mt-7 block text-left text-[10px] font-black uppercase tracking-[.2em] text-[#F7E04B]" htmlFor="nacanaca-email">Tu correo o usuario</label>
        <input
          id="nacanaca-email"
          value={email}
          onChange={(event) => { setEmail(event.target.value); setEmailError(''); }}
          type="text"
          autoComplete="username"
          required
          placeholder="tu@correo.com o DiabloToluca"
          className={[
          'mt-2 w-full border-b border-[#7EC54A]/60 bg-transparent px-1 py-3 text-lg font-bold',
          'text-white outline-none placeholder:text-[#8FA98E] focus:border-[#F7E04B]',
          ].join(' ')}
        />
        {emailError && <p className="mt-2 text-left text-xs font-bold text-[#F7E04B]" role="alert">{emailError}</p>}
        {formNotice && <p className="mt-2 text-left text-xs leading-5 text-[#C5E6A0]">{formNotice}</p>}
        <p className="mt-3 text-left text-[11px] leading-4 text-[#8FA98E]">Si ya verificaste tu cuenta en este dispositivo, entras directo sin código.</p>
        <button type="submit" disabled={isCheckingEmail} className={`${replayButton} mt-6 disabled:opacity-60`}>{isCheckingEmail ? 'Validando…' : 'Validar'}</button>
        </form>
      </>
    ) : onboardingStep === 'register' ? (
      <>
        <div className="logo-layer relative mx-auto w-[min(82vw,340px)] shrink-0 [isolation:isolate]">
          <img src={logoInicio} alt="La Maldición del Ñaca Ñaca" draggable="false" className="block h-auto w-full object-contain" />
        </div>
        <div className="mt-6 border border-[#7EC54A]/40 bg-black/90 p-5 text-left shadow-[6px_6px_0_rgba(0,0,0,.4)]">
          <p className="text-[10px] font-black uppercase tracking-[.22em] text-[#7EC54A]">Cuenta nueva</p>
          <h2 className="mt-2 font-display text-3xl uppercase leading-none text-white">Elige tu nombre</h2>
          <p className="mt-3 text-sm leading-6 text-[#C5E6A0]">Correo: <span className="break-all font-black text-white">{email.trim()}</span></p>
          {formNotice && <p className="mt-2 text-xs leading-5 text-[#F7E04B]">{formNotice}</p>}
          <form onSubmit={continueWithRegistration} noValidate>
            <label className="mt-5 block text-[10px] font-black uppercase tracking-[.2em] text-[#F7E04B]" htmlFor="nacanaca-username">Nombre de usuario</label>
            <input
              id="nacanaca-username"
              value={name}
              onChange={(event) => { setName(event.target.value); setNameError(''); }}
              maxLength="18"
              required
              autoFocus
              placeholder="Ej. DiabloToluca"
              className={[
              'mt-2 w-full border-b border-[#7EC54A]/60 bg-transparent px-1 py-3 text-lg font-bold',
              'text-white outline-none placeholder:text-[#8FA98E] focus:border-[#F7E04B]',
              ].join(' ')}
            />
            {nameError && <p className="mt-2 text-xs font-bold text-[#F7E04B]" role="alert">{nameError}</p>}
            <p className="mt-3 text-[11px] leading-4 text-[#8FA98E]">Te guardaremos como usuario no validado y te enviaremos un código para activar tu cuenta. Tu nombre será visible en el ranking.</p>
            <label htmlFor="nacanaca-event-optin" className="mt-3 flex min-h-[44px] cursor-pointer items-start gap-3 text-left text-[11px] leading-4 text-[#8FA98E]">
              <input
                id="nacanaca-event-optin"
                type="checkbox"
                checked={acceptsEventInfo}
                onChange={(event) => setAcceptsEventInfo(event.target.checked)}
                className="mt-0 h-5 w-5 shrink-0 cursor-pointer accent-[#7EC54A]"
              />
              <span>¿Te gustaría recibir información de nuestros eventos en Toluca?</span>
            </label>
            <button type="submit" disabled={isRegistering} className={`${replayButton} mt-6 disabled:opacity-60`}>{isRegistering ? 'Creando…' : 'Crear cuenta y enviar código'}</button>
          </form>
          <button
            type="button"
            onClick={() => { setOnboardingStep('email'); setFormNotice(''); }}
            className="mt-5 w-full text-center text-xs font-bold uppercase tracking-wider text-[#F7E04B] underline underline-offset-4"
          >
            Cambiar correo
          </button>
        </div>
      </>
    ) : onboardingStep === 'verification' ? (
      <>
        <div className="logo-layer relative mx-auto w-[min(82vw,340px)] shrink-0 [isolation:isolate]">
          <img src={logoInicio} alt="La Maldición del Ñaca Ñaca" draggable="false" className="block h-auto w-full object-contain" />
        </div>
        <div className="mt-6 border border-[#F7E04B]/40 bg-black/90 p-5 text-left shadow-[6px_6px_0_rgba(0,0,0,.4)]">
          <p className="text-[10px] font-black uppercase tracking-[.22em] text-[#7EC54A]">Verifica tu identidad</p>
          <h2 className="mt-2 font-display text-3xl uppercase leading-none text-white">Revisa tu correo</h2>
          <p className="mt-4 text-sm leading-6 text-[#C5E6A0]">Escribe el código de 6 dígitos enviado a <span className="break-all font-black text-white">{email.trim()}</span>.</p>
          {mailNotice && <p className="mt-3 border-l-2 border-[#7EC54A] pl-3 text-xs leading-5 text-[#C5E6A0]">{mailNotice}</p>}
          {authMode === 'login' && <p className="mt-2 text-[11px] leading-4 text-[#8FA98E]">También te enviamos un enlace para entrar directo sin escribir el código.</p>}
          <form onSubmit={continueWithVerification} noValidate>
            <label className="mt-7 block text-[10px] font-black uppercase tracking-[.2em] text-[#F7E04B]" htmlFor="nacanaca-verification-code">Código de verificación</label>
            <input
              id="nacanaca-verification-code"
              value={verificationCode}
              onChange={(event) => {
                setVerificationCode(event.target.value.replace(/\D/g, '').slice(0, 6));
                setVerificationError('');
              }}
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength="6"
              autoFocus
              required
              placeholder="000000"
              aria-describedby={verificationError ? 'nacanaca-verification-error' : undefined}
              className={[
                'mt-3 w-full border border-[#7EC54A]/60 bg-[#0A1A0F]/80 px-4 py-4 text-center font-mono',
                'text-3xl font-black tracking-[.32em] text-white outline-none placeholder:text-[#476A48]',
                'focus:border-[#F7E04B]',
              ].join(' ')}
            />
            {verificationError && <p id="nacanaca-verification-error" className="mt-2 text-xs font-bold text-[#F7E04B]">{verificationError}</p>}
            <button type="submit" disabled={isVerifying} className={`${replayButton} mt-6 disabled:opacity-60`}>{isVerifying ? 'Verificando…' : 'Verificar correo'}</button>
          </form>
          <button type="button" onClick={resendCode} disabled={isResending} className={[
            'mt-4 w-full text-center text-xs font-bold uppercase tracking-wider text-white underline',
            'underline-offset-4 disabled:opacity-60',
          ].join(' ')}>{isResending ? 'Reenviando…' : 'Reenviar código'}</button>
          <button
            type="button"
            onClick={() => setOnboardingStep('email')}
            className="mt-3 w-full text-center text-xs font-bold uppercase tracking-wider text-[#F7E04B] underline underline-offset-4"
          >
            Cambiar correo
          </button>
        </div>
      </>
    ) : (
      <>
        <img src={nacanacaLogo} alt="Ñaca Ñaca" className="mx-auto h-auto w-20 shrink-0 object-contain drop-shadow-[0_8px_22px_rgba(0,0,0,.55)] md:w-28" />
        <div className="mt-4 text-left md:mt-5">
        <div className="border border-[#F7E04B]/40 bg-black/90 p-3 shadow-[4px_4px_0_rgba(0,0,0,.35)] md:p-4">
          <p className="text-[10px] font-black uppercase tracking-[.2em] text-[#F7E04B]">Antes de entrar · instrucciones</p>
          <h2 className="mt-2 font-display text-2xl uppercase leading-none text-white">Cómo maldecir Toluca</h2>
          <p className="mt-2 text-xs leading-5 text-[#C5E6A0]">Jugarás como <span className="font-black text-white">{name || '—'}</span> <span className="text-[#8FA98E]">· {email}</span></p>
          <ol className="mt-4 grid gap-3">
            <li className="flex gap-3 border border-[#7EC54A]/25 bg-black/25 p-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center bg-[#F7E04B] font-display text-sm leading-none text-[#0A1A0F]">1</span>
              <p className="text-xs leading-5 text-white"><span className="font-black text-[#F7E04B]">Sigue el ritmo.</span> Las notas caen por dos carriles hacia el receptor al beat de la música.</p>
            </li>
            <li className="flex gap-3 border border-[#7EC54A]/25 bg-black/25 p-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center bg-[#F7E04B] font-display text-sm leading-none text-[#0A1A0F]">2</span>
              <p className="text-xs leading-5 text-white">
                <span className="font-black text-[#F7E04B]">Toca a tiempo.</span> Pulsa izquierda{' '}
                <span className="rounded bg-white/10 px-1 font-mono text-[11px]">←</span> o derecha{' '}
                <span className="rounded bg-white/10 px-1 font-mono text-[11px]">→</span> / toca el lado correspondiente
                cuando la nota llegue. ¡La precisión suma más puntos!
              </p>
            </li>
            <li className="flex gap-3 border border-[#7EC54A]/25 bg-black/25 p-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center bg-[#F7E04B] font-display text-sm leading-none text-[#0A1A0F]">3</span>
              <p className="text-xs leading-5 text-white">
                <span className="font-black text-[#F7E04B]">Mantén pulsado.</span> En notas largas, no sueltes hasta que termine la estela.
                Si sueltas antes, pierdes la racha.
              </p>
            </li>
            <li className="flex gap-3 border border-[#7EC54A]/25 bg-black/25 p-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center bg-[#F7E04B] font-display text-sm leading-none text-[#0A1A0F]">4</span>
              <p className="text-xs leading-5 text-white">
                <span className="font-black text-[#F7E04B]">Maldice y multiplica.</span> Cada fallo te quita tiempo.
                Mantén la racha para activar <span className="font-black">x2 · x3 · x4</span>.
              </p>
            </li>
            <li className="flex gap-3 border border-[#7EC54A]/25 bg-black/25 p-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center bg-[#F7E04B] font-display text-sm leading-none text-[#0A1A0F]">5</span>
              <p className="text-xs leading-5 text-white"><span className="font-black text-[#F7E04B]">Maldice a tus amigos.</span> Lanza un reto con un amigo y gana más puntos.</p>
            </li>
          </ol>
          <div className="mt-4 border border-[#C9A8FF]/35 bg-[#1A1033]/70 p-3">
            <p className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[.18em] text-[#C9A8FF]">
              <span className="flex h-5 w-5 items-center justify-center bg-[#C9A8FF] text-[10px] leading-none text-[#0A1A0F]">◈</span>
              MAPA · Maldice tu territorio
            </p>
            <ol className="mt-3 grid gap-2">
              <li className="flex gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center bg-[#C9A8FF] font-display text-xs leading-none text-[#0A1A0F]">1</span>
                <p className="text-xs leading-5 text-white">
                  <span className="font-black text-[#C9A8FF]">Posición maldita.</span> El mapa te posicionará en la zona más cercana a ti
                  para comenzar la maldición.
                </p>
              </li>
              <li className="flex gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center bg-[#C9A8FF] font-display text-xs leading-none text-[#0A1A0F]">2</span>
                <p className="text-xs leading-5 text-white">
                  <span className="font-black text-[#C9A8FF]">Puntos ocultos.</span>{' '}
                  <img
                    src={puntos1}
                    alt=""
                    className="ml-1 inline h-7 w-7 object-contain align-[-6px] drop-shadow-[0_1px_4px_rgba(0,0,0,.45)]"
                    aria-hidden="true"
                    title="Así se ven los puntos"
                  />{' '}
                  Explora cada rincón: el mapa esconde puntos extra. ¡No dejes que se te escape ninguno!
                </p>
              </li>
            </ol>
          </div>
          <div className="mt-4 flex gap-2 border-t border-[#7EC54A]/20 pt-4 text-[10px] font-black uppercase tracking-[.14em] text-[#C5E6A0]">
            <span className="rounded-sm border border-[#7EC54A]/40 bg-black/30 px-2 py-1">🎧 Usa audífonos</span>
            <span className="rounded-sm border border-[#7EC54A]/40 bg-black/30 px-2 py-1">📱 Juega en vertical</span>
          </div>
        </div>
        <button type="button" onClick={enterFromInstructions} className={[
          'w-full rounded-sm border border-[#F7E04B] bg-[#7C3AED] px-5 py-4 font-black uppercase',
          'tracking-[.12em] text-white shadow-[4px_4px_0_#0A1A0F] transition-transform',
          'active:translate-x-0.5 active:translate-y-0.5 hover:bg-[#6D2EB5] mt-5',
        ].join(' ')}>Siguiente</button>
        <button
          type="button"
          onClick={() => setOnboardingStep('email')}
          className="mt-3 w-full text-center text-xs font-bold uppercase tracking-wider text-[#F7E04B] underline underline-offset-4"
        >
          Corregir datos
        </button>
        </div>
        </>
    )}
  </Panel>
  );
}
